import { defineGame } from "./game-definition.js";
import { QUIZ_BUZZER_PHASES, canTransitionQuizBuzzer, transitionQuizBuzzer } from "./quiz-buzzer-machine.js";
export const PITCH_CHALLENGE_DEFAULT_CONFIG = Object.freeze({
    rounds: 10,
    answerDurationMs: 8_000,
    roundResultDurationMs: 4_000,
    maxPoints: 1_200,
    toleranceCents: 200,
    clarityFloor: 0.75
});
const actions = ["START", "ANSWER", "ROUND_COMPLETE", "NEXT_ROUND", "FINISH", "PAUSE", "RESUME", "SKIP_ROUND", "END", "PLAY_AGAIN"];
export const PITCH_CHALLENGE_DEFINITION = defineGame({
    key: "PITCH_CHALLENGE",
    metadata: {
        slug: "pitch-challenge",
        name: "Pitch Challenge",
        description: "Ascolta la nota, cantala nel microfono e conquista punti per precisione.",
        icon: "🎤",
        catalogStatus: "available",
        maturity: "experimental",
        hostAccess: true,
        minimumPlayers: 1,
        maximumPlayers: 100,
        capabilities: ["realtime", "qr-join", "public-display", "persistent-ranking", "questions", "audio-output", "microphone"]
    },
    initialConfig: PITCH_CHALLENGE_DEFAULT_CONFIG,
    supportedConfiguration: ["rounds", "answerDurationMs", "roundResultDurationMs", "maxPoints", "toleranceCents", "clarityFloor"],
    configurationProfiles: {
        quick: { configuration: { rounds: 5, answerDurationMs: 7_000, roundResultDurationMs: 2_500 }, estimatedMinutes: 5 },
        standard: { configuration: {}, estimatedMinutes: 9 },
        extended: { configuration: { rounds: 14, answerDurationMs: 10_000 }, estimatedMinutes: 13 }
    },
    createInitialState: (config = {}) => ({
        phase: "LOBBY",
        roundNumber: 0,
        totalRounds: config.rounds ?? PITCH_CHALLENGE_DEFAULT_CONFIG.rounds,
        pausedFromPhase: null
    }),
    states: QUIZ_BUZZER_PHASES,
    actions,
    canTransition: (state, action) => canTransitionQuizBuzzer(state.phase, action),
    transition: (state, action) => ({
        ...state,
        phase: transitionQuizBuzzer(state.phase, action, state.pausedFromPhase === "QUESTION" || state.pausedFromPhase === "ROUND_RESULT"
            ? { resumePhase: state.pausedFromPhase }
            : {})
    }),
    scoreDelta: (decision) => ({ PERFECT: 1_200, GREAT: 900, CLOSE: 450, MISS: 0 })[decision],
    views: {
        host: "pitch-challenge/host",
        player: "pitch-challenge/player",
        display: "pitch-challenge/display"
    },
    realtime: {
        clientToServer: ["host:start", "host:pause", "host:resume", "host:skip-round", "host:end", "host:play-again", "player:pitch"],
        serverToClient: ["action-result", "action-error", "pitch-result"]
    }
});
//# sourceMappingURL=pitch-challenge-definition.js.map